import { types } from 'mobx-state-tree'
import { Address } from './Address'

const Contact = types
  .model('Contact', {
    email: types.string,
    mobile: types.string,
    website: types.string,
    addresses: types.array(Address), // Can have Business and Residentail address
  })
  .actions((self) => ({
    pushAddress(address: any): void {
      const own = self
      own.addresses.push(address)
    },
    clearAddress(): void {
      self.addresses.clear()
    },
    updateContactEmail(emailId: string): void {
      const own = self
      own.email = emailId
    },
    updateContactWebsite(webaddress: string): void {
      const own = self
      own.website = webaddress
    },
  }))

export { Contact }
